export const applyAbstractStyle = async (canvas, ctx, setMessage, language) => {
  // 추상주의: 형태의 파괴와 색과 선의 조합
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 색상 추상화
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // 색상을 기본 팔레트로 매핑
    if (r > g && r > b) {
      // 빨간색 계열
      data[i] = 255;
      data[i + 1] = Math.random() > 0.5 ? 0 : 100;
      data[i + 2] = Math.random() > 0.5 ? 0 : 100;
    } else if (g > r && g > b) {
      // 녹색 계열
      data[i] = Math.random() > 0.5 ? 0 : 100;
      data[i + 1] = 255;
      data[i + 2] = Math.random() > 0.5 ? 0 : 100;
    } else if (b > r && b > g) {
      // 파란색 계열
      data[i] = Math.random() > 0.5 ? 0 : 100;
      data[i + 1] = Math.random() > 0.5 ? 0 : 100;
      data[i + 2] = 255;
    } else {
      // 중성색 계열
      const gray = (r + g + b) / 3;
      data[i] = gray > 128 ? 255 : 0;
      data[i + 1] = gray > 128 ? 255 : 0;
      data[i + 2] = gray > 128 ? 255 : 0;
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 형태 파괴 및 재구성
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const abstractData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const abstractPixels = abstractData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 랜덤 영역 재배치
  const patchSize = 30;
  for (let i = 0; i < 50; i++) {
    const sourceX = Math.floor(Math.random() * (canvas.width - patchSize));
    const sourceY = Math.floor(Math.random() * (canvas.height - patchSize));
    const destX = Math.floor(Math.random() * (canvas.width - patchSize));
    const destY = Math.floor(Math.random() * (canvas.height - patchSize));
    
    for (let dy = 0; dy < patchSize; dy++) {
      for (let dx = 0; dx < patchSize; dx++) {
        const sourcePos = ((sourceY + dy) * canvas.width + (sourceX + dx)) * 4;
        const destPos = ((destY + dy) * canvas.width + (destX + dx)) * 4;
        
        // 색상 혼합
        abstractPixels[destPos] = (tempData[sourcePos] + abstractPixels[destPos]) / 2;
        abstractPixels[destPos + 1] = (tempData[sourcePos + 1] + abstractPixels[destPos + 1]) / 2;
        abstractPixels[destPos + 2] = (tempData[sourcePos + 2] + abstractPixels[destPos + 2]) / 2;
      }
    }
  }
  
  ctx.putImageData(abstractData, 0, 0);
  
  // 3. 추상적 선과 도형 추가
  ctx.strokeStyle = 'black';
  ctx.lineWidth = 3;
  
  // 랜덤 선 그리기
  for (let i = 0; i < 20; i++) {
    ctx.beginPath();
    ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
    ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
    ctx.stroke();
  }
  
  // 랜덤 원 그리기
  for (let i = 0; i < 10; i++) {
    ctx.beginPath();
    ctx.arc(
      Math.random() * canvas.width,
      Math.random() * canvas.height,
      Math.random() * 50 + 10,
      0,
      2 * Math.PI
    );
    ctx.strokeStyle = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
    ctx.stroke();
  }
};